import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import { useState, useEffect } from 'react'
import { Outlet, useNavigate, useLocation } from 'react-router-dom'
import { useIntl } from 'react-intl'

const tabsConfig = [
  {
    label: 'receptions',
    route: '/m/facility/rooms/receptions',
  },
  {
    label: 'waitingRooms',
    route: '/m/facility/rooms/waiting-rooms',
  },
  {
    label: 'examRooms',
    route: '/m/facility/rooms/exam-rooms',
  },
  {
    label: 'prepRooms',
    route: '/m/facility/rooms/prep-rooms',
  },
  {
    label: 'doctorOffices',
    route: '/m/facility/rooms/offices',
  },
  {
    label: 'labWorkstations',
    route: '/m/facility/rooms/lab-workstations',
  }
]

export default function Rooms() {
  const navigate = useNavigate()
  const location = useLocation()
  const intl = useIntl()

  const getTabValue = () => {
    const path = location.pathname
    if (path.includes('/receptions')) return 0
    if (path.includes('/waiting-rooms')) return 1
    if (path.includes('/exam-rooms')) return 2
    if (path.includes('/prep-rooms')) return 3
    if (path.includes('/offices')) return 4
    if (path.includes('/lab-workstations')) return 5
    return 0
  }

  const [value, setValue] = useState(getTabValue())

  useEffect(() => {
    setValue(getTabValue())
  }, [location.pathname])

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
    navigate(tabsConfig[newValue].route)
  }

  return (
    <Box>
      <Box
        sx={{
          marginTop: '5px',
        }}
      >
        <Tabs
          indicatorColor="primary"
          textColor="primary"
          value={value}
          onChange={handleChange}
          aria-label="rooms-tabs"
          sx={{
            marginLeft: '24px',
            marginBottom: '-22px',
          }}
        >
          {tabsConfig.map((tab, index) => (
            <Tab
              key={index}
              label={intl.formatMessage({ id: tab.label })}
              sx={{
                backgroundColor: '#fff',
                borderRadius: '5px 5px 0px 0px',
              }}
            />
          ))}
        </Tabs>
      </Box>
      <Box sx={{ height: '100%', py: 3 }}>
        <Outlet />
      </Box>
    </Box>
  )
}
